export default __webpack_public_path__ + "static/media/icons8-slider-96.f8ad34e0.svg";